export const WORDS = [
  'bread',
  'mfers',
  'snail',
  'steak',
  'house',
  'berry',
  'razor',
  'phone',
  'shark',
  'chart',
  'chili',
  'flash',
  'jello',
  'gavel',
  'raven',
  'shade',
  'oreos',
  'sword',
  'globe',
  'mixer',
  'thumb',
  'boxer',
  'ducky',
  'tiger',
  'xcopy',
  'broom',
  'chips',
  'paint',
  'brush',
  'light',
  'bossy',
  'brain',
  'legos',
  'plane',
  'ghost',
  'grape',
  'heart',
  'trees',
  'piggy',
  'robot',
  'fence',
  'watch',
  'chain',
  'gnome',
  'onion',
  'stars',
  'squid',
  'hippo',
  'glove',
  'mouse',
  'igloo',
  'cloud',
  'board',
  'tooth',
  'skate',
  'value',
  'pizza',
  'whale',
  'puppy',
  'zebra',
  'train',
  'donut',
  'smile',
  'panda',
  'froyo',
  'fries',
  'melon',
  'ruler',
]
